// 협업 앱(NC/MM) 임베드 공용 설정·헬퍼 — EmbedPage에서 분리(순수 데이터/자족 함수, 동작 100% 동일).

// NC_APPS: NC 세션체크+SSO를 타는 앱들(드라이브 외 캘린더·메일·화상회의·협업도구·오피스).
export const NC_APPS = ['drive', 'calendar', 'mail', 'talk', 'collabtools'];

// NC 앱별 헤더 라벨/아이콘(메일·화상회의 #header 잡메뉴 숨김 후 좌측 정적 라벨 — 드라이브 cleanupDriveHeader 패턴).
export const NC_HDR = {
  mail:     { label: '메일',     svg: '<svg viewBox="0 0 24 24" width="20" height="20" style="fill:currentColor"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>' },
  talk:     { label: '화상회의', svg: '<svg viewBox="0 0 24 24" width="20" height="20" style="fill:currentColor"><path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/></svg>' },
  calendar: { label: '캘린더',   svg: '<svg viewBox="0 0 24 24" width="20" height="20" style="fill:currentColor"><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2z"/></svg>' },
};

// NC 임베드의 세션이 죽었는지 판정(같은 오리진이라 iframe 문서 접근 가능).
// 확실한 근거만 dead로 본다. 오탐은 멀쩡한 화면을 리로드해 사용자 작업을 날리므로 미탐보다 나쁘다.
export function isNcSessionDead(win) {
  try {
    if (!win) return false;
    const path = (win.location && win.location.pathname) || '';
    if (/\/login(\/|$)/.test(path)) return true;
    const doc = win.document;
    if (doc && doc.getElementById && doc.getElementById('body-login')) return true;
    return false;
  } catch (e) {
    return false;
  }
}

// ── MM 자동 연결(#175 ②) ──
// 드라이브의 'NC→메신저로 보내기'는 사용자별 MM OAuth 연결을 요구(원래는 개인설정에서 'Connect' 수동 클릭).
// 게이트웨이 SPA와 NC/MM은 동일 오리진(ai.ourbox.co.kr)이라, personalSettings.js의 연결 흐름을 부모에서 그대로 재현해 자동화:
//   ① is-connected로 상태 확인(미연결일 때만, 자가치유=토큰 유실 시 재연결)
//   ② oauth_state를 NC user config에 저장(PUT /config)
//   ③ trusted+SSO authorize를 숨은 iframe으로 → oauth-redirect가 토큰 저장(무동의·무중단)
// MM 세션이 있어야 무동의 자동승인 → MM 세션 확인 후에만 시도(없으면 다음 방문 때 재시도). client_id·instance는 is-connected가 반환(하드코딩 X).
let mmConnectTried = false;
export async function autoConnectMattermost() {
  if (mmConnectTried) return;
  // is-connected는 @NoCSRFRequired가 아니라서 requesttoken 없이 부르면 NC가 412(CSRF check failed)로 거부 →
  //   자동연결이 line의 !r.ok에서 즉시 죽었음(#175 잠복버그, 콘솔 embedCollab.js 412의 정체).
  // 해결: /drive/ HTML의 data-requesttoken을 먼저 확보(NC 세션 있어야 발급)해 is-connected 포함 모든 호출에 동봉.
  let token = '';
  try {
    const html = await (await fetch('/drive/', { credentials: 'include' })).text();
    const m = html.match(/data-requesttoken="([^"]+)"/);
    token = m ? m[1] : '';
  } catch (e) { return; }
  if (!token) return;   // NC 세션 없음 → 다음 방문 재시도
  let st;
  try {
    const r = await fetch('/drive/apps/integration_mattermost/is-connected', { credentials: 'include', headers: { requesttoken: token } });
    if (!r.ok) return;
    st = await r.json();
  } catch (e) { return; }
  if (!st || st.connected) { mmConnectTried = true; return; }   // 이미 연결됨 → 끝
  if (!st.oauth_possible || !st.client_id || !st.url) return;    // OAuth 설정 미비 → 조용히 패스
  try { const me = await fetch('/mm/api/v4/users/me', { credentials: 'include' }); if (!me.ok) return; } catch (e) { return; }  // MM 세션 없음 → 재시도 보류
  mmConnectTried = true;
  const redirectUri = window.location.origin + '/drive/apps/integration_mattermost/oauth-redirect';
  const state = Math.random().toString(36).substring(3);
  try {
    const r = await fetch('/drive/apps/integration_mattermost/config', {
      method: 'PUT', credentials: 'include',
      headers: { requesttoken: token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ values: { oauth_state: state, redirect_uri: redirectUri, oauth_origin: 'settings' } }),
    });
    if (!r.ok) { mmConnectTried = false; return; }
  } catch (e) { mmConnectTried = false; return; }
  const authUrl = String(st.url).replace(/\/+$/, '') + '/oauth/authorize?client_id='
    + encodeURIComponent(st.client_id) + '&redirect_uri=' + encodeURIComponent(redirectUri)
    + '&response_type=code&state=' + encodeURIComponent(state);
  const f = document.createElement('iframe');
  f.setAttribute('aria-hidden', 'true');
  f.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0;border:0;pointer-events:none';
  const cleanup = () => { try { f.parentNode && f.parentNode.removeChild(f); } catch (e) { /* */ } };
  f.onload = () => setTimeout(cleanup, 2500);  // authorize→redirect 체인 완료 후 정리(연결 여부는 다음 방문 is-connected가 진실원)
  setTimeout(cleanup, 15000);                   // 백스톱(onload 미발화 대비)
  f.src = authUrl;
  document.body.appendChild(f);
}
